import React, { Component } from 'react';
import './_styles.scss';
import ButtonPrimary from './ButtonPrimary/index';
import ButtonTelmex from './ButtonTelmex/index';
import Translator from 'src/requests/apa/Translator';
import Asset from 'src/requests/apa/Asset';
import Utils from 'src/utils/Utils';
import { setInitialFocus } from 'src/utils/Utils';
import { LOGIN, REGISTER } from 'src/components/Modal/LoginQR/const';
import { handleClickIniciaSesion, handleClickRegistraCorreo, handleClickRegistroTelmex } from '../LandingTelmex/utilsLandingTelmex';
import Carrusel from './components/carrusel/Carrusel';
import { getDynamicImage, getImageFromAsset, secondsToMiliseconds } from '../../../utils/Utils';
import { id } from 'date-fns/locale';
export default class LandingTelmex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cards: null,
      backgrounds: null,
      isTransitioning: false
    };
    const {carousel_config} = Utils.getRegionaliazedMetadata('landing_telmex_config', '{carousel_config: {enable:false}}');
    this.carousel_config = carousel_config || {enable:false};

  }

  async componentDidMount() {
    setInitialFocus('.landing-telmex__button-telmex');
    const images = (this.carousel_config.enable) ?  await getDynamicImage() : getImageFromAsset();
    
    // Verificar si images es un array de objetos o array plano
    const isObjectArray = Array.isArray(images) && images.length > 0 && typeof images[0] === 'object'
    
    const { cards, backgrounds } = isObjectArray
      ? this.separateImageFromApi(images) 
      : this.separateImageFromAsset(images);
    this.setState({ cards, backgrounds });
  }

  // Separar las imágenes en cards y backgrounds cuando vienen de la API
  separateImageFromApi(images) {
    const cards = [];
    const backgrounds = [];
    images.forEach((item, index) => {
      cards.push({
        id: index,
        image: item.image_card_landscape
      });
      backgrounds.push({
        id: index,
        image: item.image_background_landscape
      });
    });
    return { backgrounds, cards };
  }

  // Separar las imágenes en cards y backgrounds cuando vienen de apa/assets
  separateImageFromAsset(images) {
    const cards = images.slice(0, -1).map((image, index) => ({ id: index, image }));
    const backgrounds = [{ id: images.length - 1, image: images[images.length - 1] }];
    return { backgrounds, cards };
  }
  
  // Función para rotar los fondos de pantalla
  rotateBackgrounds = () => {
    if(this.state.backgrounds.length <= 1) return;

    this.setState({ isTransitioning: true });
    setTimeout(() => {
      this.setState((prevState) => {
        const copy = [...prevState.backgrounds];
        copy.push(copy.shift());
        return { backgrounds: copy, isTransitioning: false };
      });
    }, 2000); 
  }



  render() {
    const { cards, backgrounds, isTransitioning } = this.state;

    return (
      <div className='landing-telmex ' id="landingtelmex">
        <div className={`background-image ${isTransitioning ? 'animate-background invisible' : 'visible'}`} style={{ backgroundImage: `url(${backgrounds && backgrounds[0].image})` }} />
        {
          backgrounds && backgrounds[1] && (
            <div className={`background-image ${isTransitioning ? 'animate-background visible' : 'invisible'}`} style={{ backgroundImage: `url(${backgrounds && backgrounds[1].image})` }} />
          )
        }
        <div className="landing-telmex__header">
          <div className="landing-telmex__login-label">
            {Utils.cutPlayerString(
              Translator.get('Landing_Texto_Parrafo_YaTienesCuenta'),
              22
            )}
          </div>
          <ButtonPrimary
            title={Utils.cutPlayerString(
              Translator.get('Landing_Boton_Texto_IniciaSesion'),
              25
            )}
            type={LOGIN}
            onClick={() => handleClickIniciaSesion(this.props)}
          />
        </div>
        <div className="landing-telmex__row">
          <div className="landing-telmex__column landing-telmex__column--left">
            <img
              className="landing-telmex__logo"
              src={Asset.get('Landing_Logo_ClaroVideo')}
              alt="Claro Video"
            />
            <div className="landing-telmex__title landing-telmex__title--part-1">
              {Utils.cutPlayerString(
                Translator.get(
                  'Landing_PaginaPrincipal_Seccion1_Texto_Titulo_Parte1'
                ),
                32
              )}
            </div>
            <div className="landing-telmex__title landing-telmex__title--part-2">
              {Utils.cutPlayerString(
                Translator.get(
                  'Landing_PaginaPrincipal_Seccion1_Texto_Titulo_Parte2'
                ),
                32
              )}
            </div>
            <div className="landing-telmex__paragraph-1 landing-telmex__paragraph-1--part-1">
              {Utils.cutPlayerString(
                Translator.get(
                  'Landing_PaginaPrincipal_Seccion1_Texto_Parrafo1_Parte1'
                ),
                38
              )}
            </div>
            <div className="landing-telmex__paragraph-1 landing-telmex__paragraph-1--part-2">
              {Utils.cutPlayerString(
                Translator.get(
                  'Landing_PaginaPrincipal_Seccion1_Texto_Parrafo1_Parte2'
                ),
                38
              )}{' '}
              <span className="landing-telmex__paragraph-1 landing-telmex__paragraph-1--part-3">
                {Utils.cutPlayerString(
                  Translator.get(
                    'Landing_PaginaPrincipal_Seccion1_Texto_Parrafo1_Parte3'
                  ),
                  38
                )}
              </span>
            </div>
            <ButtonTelmex
              icon={Asset.get(
                'Landing_PaginaPrincipal_Boton_Logo_Telmex'
              )}
              onClick={() => handleClickRegistroTelmex(this.props)}
            />
            <div className="landing-telmex__paragraph-2">
              {Utils.cutPlayerString(
                Translator.get(
                  'Landing_PaginaPrincipal_Seccion1_Texto_Parrafo2'
                ),
                38
              )}
            </div>
            <ButtonPrimary
              title={Utils.cutPlayerString(
                Translator.get('Landing_Boton_Texto_RegistrateConCorreo'),
                25
              )}
              type={REGISTER}
              onClick={() => handleClickRegistraCorreo(this.props)}
            />
          </div>
          <div className="landing-telmex__column landing-telmex__column--right">
            { cards && 
              <Carrusel 
                images={cards} 
                {...(this.carousel_config.enable  && backgrounds && backgrounds.length > 1 && {
                  animationConfig: {
                    interval: secondsToMiliseconds(this.carousel_config.seconds_to_transition),
                    onTransition: this.rotateBackgrounds
                  }
                })}
              />
            }
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/authentication/components/LandingTelmex/index.jsx